import { createTheme } from '@mui/material/styles'

// Single source of truth for brand colors
const BRAND_YELLOW = 'rgb(254, 211, 70)'
const BRAND_BLACK = '#1a1a1a'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: BRAND_YELLOW,
      contrastText: BRAND_BLACK,
    },
    secondary: {
      main: '#ffffff',
      contrastText: BRAND_BLACK,
    },
    text: {
      primary: BRAND_BLACK,
    }
  },
  shape: { borderRadius: 10 },
  typography: {
    h1: { fontWeight: 800, letterSpacing: '-0.5px' },
    h2: { fontWeight: 700, letterSpacing: '-0.3px' },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderWidth: 2 },
        containedPrimary: { color: BRAND_BLACK },
        outlinedPrimary: { borderColor: BRAND_BLACK, color: BRAND_BLACK }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: { backgroundColor: '#fff', color: BRAND_BLACK, boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }
      }
    }
  }
})

export default theme
export { BRAND_YELLOW, BRAND_BLACK }
